import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../../../services/ApiService'
import { showAlert } from '../../../../utility/SweetAlert'

const InteractorTeamAccountView = () => {
  const { t } = useTranslation()

  const accountView = useCallback(
    (payload, callback, loading) => {
      ApiService.jsonRequest('/team-account/view', payload, response => {
        if (response.status_code === 200) {
          callback(response.data)
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: 1500,
            redirect: '/team/manage',
          })
        }
        loading(false)
      })
    },
    [t],
  )

  return { accountView }
}

export default InteractorTeamAccountView
